
import { useState, useEffect } from 'react';

export default function Hero() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  const backgroundImages = [
    {
      url: "https://public.readdy.ai/ai/img_res/c7061196a67fbbc8b798690761cb33aa.jpg",
      alt: "테마파크"
    },
    {
      url: "https://readdy.ai/api/search-image?query=Contemporary%20PC%20gaming%20cafe%20interior%20with%20rows%20of%20high-end%20gaming%20computers%20RGB%20lighting%20comfortable%20gaming%20chairs%20and%20modern%20minimalist%20design%20featuring%20dark%20ambient%20atmosphere%20and%20professional%20esports%20setup%20for%20gamers&width=1920&height=1080&seq=hero-pc-cafe-002&orientation=landscape",
      alt: "PC방"
    },
    {
      url: "https://readdy.ai/api/search-image?query=Modern%20luxury%20karaoke%20room%20interior%20with%20sophisticated%20sound%20system%20comfortable%20leather%20sofas%20ambient%20mood%20lighting%20large%20screen%20display%20and%20elegant%20contemporary%20design%20creating%20premium%20entertainment%20space%20for%20singing%20and%20socializing&width=1920&height=1080&seq=hero-karaoke-003&orientation=landscape",
      alt: "노래방"
    },
    {
      url: "https://readdy.ai/api/search-image?query=Stylish%20party%20room%20venue%20with%20elegant%20decorations%20comfortable%20seating%20arrangements%20festive%20lighting%20setup%20spacious%20open%20layout%20and%20modern%20amenities%20perfect%20for%20celebrations%20gatherings%20and%20social%20events%20in%20contemporary%20urban%20setting&width=1920&height=1080&seq=hero-party-room-004&orientation=landscape",
      alt: "파티룸"
    },
    {
      url: "https://readdy.ai/api/search-image?query=Modern%20board%20game%20cafe%20interior%20featuring%20wooden%20tables%20shelves%20filled%20with%20colorful%20board%20games%20cozy%20seating%20areas%20warm%20ambient%20lighting%20and%20friendly%20social%20atmosphere%20where%20people%20gather%20to%20play%20and%20enjoy%20quality%20time%20together&width=1920&height=1080&seq=hero-board-game-005&orientation=landscape",
      alt: "보드게임카페"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        (prevIndex + 1) % backgroundImages.length
      );
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      {backgroundImages.map((image, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentImageIndex ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={image.url}
            alt={image.alt}
            className="w-full h-full object-cover object-top"
          />
        </div>
      ))}
      
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      
      <div className="relative z-10 w-full text-center px-6">
        <div className="flex justify-center mb-12">
          <img 
            src="https://static.readdy.ai/image/5b06d0b07a504cf8e14d395aea419754/06df2cca599ad5f4f3ba3754a63d0a06.png"
            alt="PLAY PLACE"
            className="h-48 w-auto md:h-64"
          />
        </div>
        
        <p className="text-3xl md:text-4xl text-white font-semibold mb-6">
          승부보다 머무는 시간이 즐거운 공간
        </p>
        
        <p className="text-xl md:text-2xl text-white/90 max-w-2xl mx-auto mb-4">
          놀이와 공간, 참여를 중심으로 한
        </p>
        <p className="text-xl md:text-2xl text-white/90 max-w-2xl mx-auto">
          소셜 플레이 공간 운영 브랜드
        </p>
        
        <div className="mt-12 flex flex-wrap gap-4 justify-center">
          <a
            href="#about"
            className="px-8 py-4 bg-orange-500 text-white font-semibold rounded-lg hover:bg-orange-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            회사 소개
          </a>
          <a
            href="#contact"
            className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white font-semibold rounded-lg hover:bg-white/20 transition-colors border border-white/30 whitespace-nowrap cursor-pointer"
          >
            문의하기
          </a>
        </div>
      </div>
      
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
      
      <div className="absolute bottom-8 right-8 flex gap-2">
        {backgroundImages.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentImageIndex(index)}
            className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
              index === currentImageIndex 
                ? 'bg-white w-8' 
                : 'bg-white/50 hover:bg-white/75'
            }`}
            aria-label={`이미지 ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
}
